module.exports = __webpack_public_path__ + "img/hollow-candles_select@2x.ce1118aa.svg";